import React from "react";
import moment from "moment";

const STATUS = {
  expired: {
    label: "Expired",
    className: "is-expired",
    icon: (
      <path d="m15 9-6 6M9 9l6 6M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z" />
    ),
  },
  critical: {
    label: "Expires Soon",
    className: "is-critical",
    icon: (
      <>
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
      </>
    ),
  },
  warning: {
    label: "Renewal Due",
    className: "is-warning",
    icon: (
      <>
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
      </>
    ),
  },
  active: {
    label: "Active",
    className: "is-active",
    icon: (
      <>
        <path d="M21.801 10A10 10 0 1 1 17 3.335" />
        <path d="m9 11 3 3L22 4" />
      </>
    ),
  },
};

const getStatus = (expiryDate) => {
  const today = moment();
  const expiry = moment(expiryDate);

  if (expiry.isBefore(today)) return STATUS.expired;
  if (expiry.isBefore(moment().add(10, "days"))) return STATUS.critical;
  if (expiry.isBefore(moment().add(30, "days"))) return STATUS.warning;
  return STATUS.active;
};

export const SiteLicenseCard2 = ({ tagName, expiryDate }) => {
  const status = getStatus(expiryDate);
  const formattedExpiry = moment(expiryDate).format("DD MMM YYYY");

  return (
    <div className="user_details_card2">
      <svg
        className="license-card-watermark"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" />
        <path d="M14 2v5h5" />
        <path d="m5 12 5 5-5 5" />
        <path d="M1 19h6" />
      </svg>

      <div className="license-top-row">
        <h3 className="license-card-label">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" />
            <path d="M14 2v5h5" />
            <path d="m5 12 5 5-5 5" />
            <path d="M1 19h6" />
          </svg>
          License Details
        </h3>

        <span className={`license-status-pill ${status.className}`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {status.icon}
          </svg>
          {status.label}
        </span>
      </div>

      <div className="user__details_section">
        <div className="card__text__section">
          <h2>{tagName}</h2>
        </div>

        <h3 className="license-expiry-line">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M8 2v4" />
            <path d="M16 2v4" />
            <rect width="18" height="18" x="3" y="4" rx="2" />
            <path d="M3 10h18" />
          </svg>
          Expires on {formattedExpiry}
        </h3>
      </div>
    </div>
  );
};
